/**
 * Ask the conversation's composer to take focus, e.g. from "Something else…" under a question, so the creator
 * types their own answer where they type everything else.
 *
 * On phones the composer is the host's dock (MobileChatShell), outside the surface. A host can listen for
 * `lh-composer-focus` on window and call `preventDefault()` once it has focused its composer; otherwise the
 * nearest composer textarea is focused directly (the phone dock, or the surface's own composer). Runs inside
 * the tap's handler, so iOS still brings up the keyboard.
 */
export const COMPOSER_FOCUS_EVENT = 'lh-composer-focus'

export function requestComposerFocus(from: Element | null): boolean {
    if (typeof window === 'undefined') return false
    const ev = new CustomEvent(COMPOSER_FOCUS_EVENT, { cancelable: true, detail: { from } })
    window.dispatchEvent(ev)
    if (ev.defaultPrevented) return true
    const shell = from?.closest('.chat-shell')
    const surface = from?.closest('[data-testid="agent-surface"]')
    const el = shell?.querySelector('.chat-dock textarea')
        ?? surface?.querySelector('textarea[data-testid="agent-input"]')
        ?? document.querySelector('.chat-dock textarea')
    if (el instanceof HTMLElement) {
        el.focus()
        return true
    }
    return false
}
